import { useState } from 'react'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { postManualOperation } from '../../core/api'
import { getErrorStatus, getGeneralError } from '../../../../../../common/api/errors'

const AppSwal = withReactContent(Swal)

interface Props {
  requisiteId: number
  isOpen: boolean
  onClose: () => void
  onSuccess: (newBalance: number) => void
}

const ModalManualOperation = ({ requisiteId, isOpen, onClose, onSuccess }: Props) => {
  const [amount, setAmount]   = useState('')
  const [comment, setComment] = useState('')
  const [errors, setErrors]   = useState<{ amount?: string; comment?: string }>({})
  const [loading, setLoading] = useState(false)

  const reset = () => { setAmount(''); setComment(''); setErrors({}) }

  const validate = (): boolean => {
    const next: typeof errors = {}
    const parsed = parseFloat(amount)
    if (!amount || isNaN(parsed))    next.amount  = 'Введите корректную сумму'
    else if (parsed === 0)           next.amount  = 'Сумма не может быть нулём'
    if (!comment.trim())             next.comment = 'Комментарий обязателен'
    setErrors(next)
    return Object.keys(next).length === 0
  }

  const handleSubmit = async () => {
    if (!validate()) return
    setLoading(true)
    try {
      const res = await postManualOperation(requisiteId, { amount: parseFloat(amount), comment: comment.trim() })
      if (res.data.success) {
        onSuccess(res.data.data.newBalance)
        reset()
        onClose()
        AppSwal.fire({ icon: 'success', title: 'Готово', timer: 1500, showConfirmButton: false })
      }
    } catch (e: unknown) {
      const backendMessage = getGeneralError(e)
      if (getErrorStatus(e) === 422) {
        AppSwal.fire({ icon: 'warning', title: 'Недопустимый результат', text: backendMessage ?? 'Операция приведёт к отрицательному балансу' })
      } else {
        AppSwal.fire({ icon: 'error', title: 'Ошибка сервера', text: backendMessage })
      }
    } finally {
      setLoading(false)
    }
  }

  if (!isOpen) return null

  return (
    <div className='modal fade show d-block' style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className='modal-dialog modal-dialog-centered'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>Ручная операция</h5>
            <button className='btn-close' onClick={() => { reset(); onClose() }} />
          </div>
          <div className='modal-body'>
            <div className='mb-4'>
              <label className='form-label required'>Сумма</label>
              <input
                type='number'
                step='0.01'
                className={`form-control ${errors.amount ? 'is-invalid' : ''}`}
                placeholder='Пример: 500 или -200'
                value={amount}
                onChange={e => setAmount(e.target.value)}
              />
              {errors.amount && <div className='invalid-feedback'>{errors.amount}</div>}
              <div className='form-text'>Положительное — пополнение, отрицательное — списание.</div>
            </div>
            <div className='mb-2'>
              <label className='form-label required'>Комментарий</label>
              <textarea
                rows={3}
                className={`form-control ${errors.comment ? 'is-invalid' : ''}`}
                placeholder='Причина корректировки'
                value={comment}
                onChange={e => setComment(e.target.value)}
              />
              {errors.comment && <div className='invalid-feedback'>{errors.comment}</div>}
            </div>
          </div>
          <div className='modal-footer'>
            <button className='btn btn-light' onClick={() => { reset(); onClose() }} disabled={loading}>
              Отмена
            </button>
            <button className='btn btn-primary' onClick={handleSubmit} disabled={loading}>
              {loading ? 'Выполняется…' : 'Применить'}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalManualOperation
